import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  IconButton,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import DeleteIcon from "@mui/icons-material/Delete";

import ExpenseAttachmentPreviewDialog from "./ExpenseAttachmentPreviewDialog";

import {
  getExpenseAttachments,
  uploadExpenseAttachment,
  deleteExpenseAttachment,
} from "../../../../api/Expenses/expenseAttachmentsApi";

const ExpenseItemAttachmentsDrawer = ({ item, onClose }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [attachments, setAttachments] = useState([]);

  const [preview, setPreview] = useState(null);

  const load = async () => {
    const data = await getExpenseAttachments(item.id);
    setAttachments(data);
  };

  useEffect(() => {
    load();
  }, [item]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    await uploadExpenseAttachment(item.id, file);
    e.target.value = null; // 👈 reset input
    load();
  };

  const handleDelete = async (id) => {
    await deleteExpenseAttachment(id);
    load();
  };

  return (
    <Drawer anchor="right" open onClose={onClose}>
      <Box sx={{ width: 360, p: 2 }}>
        <Typography variant="h6">Adjuntos</Typography>

        <Button component="label" sx={{ my: 2 }} fullWidth>
          📷 Hacer foto / Subir archivo
          <input
            hidden
            type="file"
            accept="image/*,application/pdf"
            capture="environment"
            onChange={handleUpload}
          />
        </Button>

        <List>
          {attachments.map((att) => {
            const isImage = ["jpg", "jpeg", "png", "webp"].includes(
              att.FileType?.toLowerCase()
            );
            const isPdf = att.FileType?.toLowerCase() === "pdf";

            return (
              <ListItem
                key={att.id}
                sx={{ cursor: "pointer" }}
                onClick={() => setPreview(att)}
                secondaryAction={
                  <IconButton edge="end" onClick={() => handleDelete(att.id)}>
                    <DeleteIcon />
                  </IconButton>
                }
              >
                <Avatar
                  variant="rounded"
                  sx={{ mr: 2, width: 56, height: 56 }}
                  src={isImage ? `${API_URL}${att.FileUrl}` : undefined}
                >
                  {isPdf ? "PDF" : "FILE"}
                </Avatar>

                <Typography variant="body2">{att.OriginalFileName}</Typography>
              </ListItem>
            );
          })}
        </List>

        <ExpenseAttachmentPreviewDialog
          open={Boolean(preview)}
          attachment={preview}
          onClose={() => setPreview(null)}
        />
      </Box>
    </Drawer>
  );
};

export default ExpenseItemAttachmentsDrawer;
